export const chattelPropertyExpensesSectionFieldsKeys = [
  'monthlyLotRent',
  'landMonthlyPayment',
  'salesTax',
];
